// DO NOT EDIT -- generated from fs/services/search-settings/retentionmetrics.proto

import * as accesscontrol from '../../shared/accesscontrol';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';
import * as visualizationsettings from './visualizationsettings';

export namespace RetentionMetrics {

  export const GetAllRetentionMetricsEndpoint = "/grpc/search_settings.RetentionMetrics/GetAllRetentionMetrics";
  /**
   * Get all current non-archived retention metrics for an org.
   * If desired, archived retention metrics can also be retrieved with the explicit request flag.
   */
  export function GetAllRetentionMetrics(sender: (req: GetAllRetentionMetricsRequest, endpoint: string) => Promise<GetAllRetentionMetricsResponse>, req: GetAllRetentionMetricsRequest): { promise: () => Promise<GetAllRetentionMetricsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllRetentionMetricsEndpoint),
      endpoint: GetAllRetentionMetricsEndpoint
    };
  }

  export const GetRetentionMetricEndpoint = "/grpc/search_settings.RetentionMetrics/GetRetentionMetric";
  /** Get a specific retention metrics, either current or past version. */
  export function GetRetentionMetric(sender: (req: GetRetentionMetricRequest, endpoint: string) => Promise<GetRetentionMetricResponse>, req: GetRetentionMetricRequest): { promise: () => Promise<GetRetentionMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetRetentionMetricEndpoint),
      endpoint: GetRetentionMetricEndpoint
    };
  }

  export const SetRetentionMetricEndpoint = "/grpc/search_settings.RetentionMetrics/SetRetentionMetric";
  /** Add a new retention metric or update an existing retention metric. */
  export function SetRetentionMetric(sender: (req: SetRetentionMetricRequest, endpoint: string) => Promise<SetRetentionMetricResponse>, req: SetRetentionMetricRequest): { promise: () => Promise<SetRetentionMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetRetentionMetricEndpoint),
      endpoint: SetRetentionMetricEndpoint
    };
  }

  export const ArchiveRetentionMetricEndpoint = "/grpc/search_settings.RetentionMetrics/ArchiveRetentionMetric";
  /**
   * Archive an existing retention metric for an org.
   * Once archived, the retention metric cannot be modified and will not show up in GetAllRetentionMetrics unless explicitly requested.
   */
  export function ArchiveRetentionMetric(sender: (req: ArchiveRetentionMetricRequest, endpoint: string) => Promise<ArchiveRetentionMetricResponse>, req: ArchiveRetentionMetricRequest): { promise: () => Promise<ArchiveRetentionMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveRetentionMetricEndpoint),
      endpoint: ArchiveRetentionMetricEndpoint
    };
  }

  export const UnarchiveRetentionMetricEndpoint = "/grpc/search_settings.RetentionMetrics/UnarchiveRetentionMetric";
  /**
   * Unarchives an existing retention metric for an org.
   * Once unarchived, the retention metric can continue to be modified and will show up in GetAllRetentionMetrics.
   */
  export function UnarchiveRetentionMetric(sender: (req: UnarchiveRetentionMetricRequest, endpoint: string) => Promise<UnarchiveRetentionMetricResponse>, req: UnarchiveRetentionMetricRequest): { promise: () => Promise<UnarchiveRetentionMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveRetentionMetricEndpoint),
      endpoint: UnarchiveRetentionMetricEndpoint
    };
  }

  export const GetRetentionMetricsAccessEndpoint = "/grpc/search_settings.RetentionMetrics/GetRetentionMetricsAccess";
  export function GetRetentionMetricsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetRetentionMetricsAccessEndpoint),
      endpoint: GetRetentionMetricsAccessEndpoint
    };
  }
}

export namespace RetentionMetricsPublic {

  export const GetRetentionMetricsAccessEndpoint = "/grpc/search_settings.RetentionMetricsPublic/GetRetentionMetricsAccess";
  export function GetRetentionMetricsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetRetentionMetricsAccessEndpoint),
      endpoint: GetRetentionMetricsAccessEndpoint
    };
  }
}

export interface GetAllRetentionMetricsRequest {
  orgId: string;
  /** If true, archived retention metric will also be returned. */
  includeArchived: boolean;
  /** By default, only public retention metrics are returned */
  includePrivate: boolean;
}

export interface GetAllRetentionMetricsResponse {
  retentionMetrics: RetentionMetricRecord[];
}

export interface GetRetentionMetricRequest {
  /** required */
  orgId: string;
  /** required */
  retentionMetricId: string;
  /** optional.  If not specified, the most recent [limit] versions will be returned. */
  version: protobuf.int64;
  /** optional, max number of records to record; defaults to safe value */
  limit: number;
}

export interface GetRetentionMetricResponse {
  versions: RetentionMetricRecord[];
}

export interface SetRetentionMetricRequest {
  orgId: string;
  /**
   * RetentionMetric to be created or updated.
   * If the id field is not set, an id will be generated and a new retention metric will be stored.
   */
  retentionMetric: RetentionMetric | null;
  visibility: protoauditstore.Visibility;
}

export interface SetRetentionMetricResponse {
  retentionMetric: RetentionMetricRecord | null;
}

export interface ArchiveRetentionMetricRequest {
  orgId: string;
  retentionMetricId: string;
}

export interface ArchiveRetentionMetricResponse {
  retentionMetric: RetentionMetricRecord | null;
}

export interface UnarchiveRetentionMetricRequest {
  orgId: string;
  retentionMetricId: string;
}

export interface UnarchiveRetentionMetricResponse {
  retentionMetric: RetentionMetricRecord | null;
}

export interface RetentionMetric {
  id: string;
  name: string;
  description: string;
  retentionMetric: segment.Retention | null;
  retentionSettings: visualizationsettings.RetentionMetricSettings | null;
}

export interface RetentionMetricRecord {
  retentionMetric: RetentionMetric | null;
  metadata: protoauditstore.AuditMetadata | null;
}
